export default {
  videos: [],
  pagination: {},
  video: {}
}
